import { FC } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { green } from '@mui/material/colors';

const Progress = styled(LinearProgress)(({ theme }) => ({
  height: '6px',
  borderRadius: '100px',
  background: theme.palette.grey[300],
  '& .MuiLinearProgress-bar1': {
    background: green[900],
  },
  '& .MuiLinearProgress-bar2': {
    background: green[500],
  },
  '& .MuiLinearProgress-dashed': {
    backgroundColor: 'lightgrey',
    backgroundImage: 'none',
    animation: 'none',
  },
}));

type Props = {
  value: number;
  valueBuffer?: number;
};

const CapitalProgress: FC<Props> = ({ value, valueBuffer = 0 }) => {
  return <Progress variant="buffer" value={value} valueBuffer={valueBuffer} />;
};

export default CapitalProgress;
